import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../utils/api';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';

export const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getCurrencyExchange: build.query({
      query: (args) => {
        const {
          page,
          perPage,
          search = '',
          toCurrency = '',
          fromDate = '',
          toDate = '',
          provider = '',
          updatedBy = '',
        } = args || {};
        const params = new URLSearchParams();

        params.append('perPage', `${perPage || DEFAULT_PER_PAGE}`);
        params.append('page', `${page || DEFAULT_PAGE}`);

        if (search) params.append('search', search);
        if (toCurrency) params.append('toCurrency', toCurrency);
        if (fromDate) params.append('fromDate', fromDate);
        if (toDate) params.append('toDate', toDate);
        if (provider) params.append('provider', provider);
        if (updatedBy) params.append('updatedBy', updatedBy);

        return `${apiUrl.exchangeRate}?${params.toString()}`;
      },
      providesTags: ['exchangeRate'],
    }),
    addCurrencyExchange: build.mutation({
      query: (data) => ({
        url: `${apiUrl.exchangeRate}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['exchangeRate'],
    }),
    getCurrencyExchangeById: build.query({
      query: (id) => `${apiUrl.exchangeRate}/${id}`,
      providesTags: ['exchangeRate'],
    }),
    updateCurrencyExchangeById: build.mutation({
      query: ({ id, ...rest }) => ({
        url: `${apiUrl.exchangeRate}/${id}`,
        method: 'PUT',
        body: rest,
      }),
      invalidatesTags: ['exchangeRate'],
    }),
    deleteCurrencyExchangeById: build.mutation({
      query: (id) => ({
        url: `${apiUrl.exchangeRate}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['exchangeRate'],
    }),
    fetchCurrencyLayerTimeframe: build.mutation({
      query: ({ fromDate, toDate }) => {
        const params = new URLSearchParams();
        params.append('fromDate', fromDate);
        params.append('toDate', toDate);

        return {
          url: `${apiUrl.currencyLayer}/timeframe?${params.toString()}`,
          method: 'GET',
        };
      },
      invalidatesTags: ['exchangeRate'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCurrencyExchangeQuery,
  useLazyGetCurrencyExchangeQuery,
  useGetCurrencyExchangeByIdQuery,
  useUpdateCurrencyExchangeByIdMutation,
  useAddCurrencyExchangeMutation,
  useDeleteCurrencyExchangeByIdMutation,
  useFetchCurrencyLayerTimeframeMutation,
} = extendedApi;
